import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=350c0a46&scoped=true&"
import script from "./AdminProducts.vue?vue&type=script&lang=js&"
export * from "./AdminProducts.vue?vue&type=script&lang=js&"
import style0 from "./AdminProducts.vue?vue&type=style&index=0&id=350c0a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c0a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350c0a46')) {
      api.createRecord('350c0a46', component.options)
    } else {
      api.reload('350c0a46', component.options)
    }
    module.hot.accept("./AdminProducts.vue?vue&type=template&id=350c0a46&scoped=true&", function () {
      api.rerender('350c0a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminProducts.vue"
export default component.exports